import bgimage from '../../../images/nepbg.png';
import nepbanner1 from "../../../images/nepbanner1.png";
import nepPattern from "../../../images/nepPattern.png";
import nepwhy from "../../../images/nepwhy1.png";
import nepwh2 from "../../../images/nepwhy2.png";
import nepwhy3 from "../../../images/nepwhy3.png";
import leftellip from "../../../images/nepleftelpi.png"
import star from "../../../images/leftstart.png"
import nepboy from "../../../images/nepboy.png"
import vector from "../../../images/Vector.png"
import rightstart from "../../../images/rightellpistart.png"
import rightelli from "../../../images/rightelli.png"
import brain from "../../../images/brain 1 (1).png"
import digital from "../../../images/digital 1.png"
import creativity from "../../../images/creativity (1) 1.png"
import cross from "../../../images/cross-country 1.png"
import { useEffect } from 'react';

import { motion } from 'framer-motion';

export default function NEP() {

   useEffect(() => {
              window.scrollTo(0, 0); // Scroll to the top of the page
            }, []);
      

  return (
    <div className="w-full h-auto bg-white flex flex-col  overflow-x-hidden">
      <div 
  className="w-full h-auto flex flex-col items-center justify-center px-3 xs:px-4 sm:px-6"
  style={{
    backgroundImage: `url(${bgimage})`,
    backgroundSize: "",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    width: "100%",
 height: "560px", 
  }}
>
  <div className="flex flex-col md:flex-row w-full max-w-[1200px] h-auto md:h-[350px] lg:h-[400px] items-center">
    
    <div className="w-full md:w-[40%] lg:w-[404px] h-[150px] xs:h-[180px] sm:h-[220px] md:h-[280px] lg:h-[325px] flex justify-center order-2 md:order-1 mt-3 xs:mt-4 md:mt-0">   
      <img 
        src={nepbanner1} 
        alt="NEP Banner" 
        className="w-full h-full object-contain" 
      />
    </div>

    <div className="w-full md:w-[60%] lg:w-[600px] md:ml-6 lg:ml-12 flex flex-col gap-0 order-1 md:order-2 text-center md:text-left">   
      <h1 className="text-[28px] xs:text-[32px] sm:text-[40px] md:text-[48px] lg:text-[60px] xl:text-[67px] font-semibold font-nunito leading-tight" style={{fontFamily:'Montserrat'}}>
        National
      </h1>
      <h1 className="text-[28px] xs:text-[32px] sm:text-[40px] md:text-[48px] lg:text-[60px] xl:text-[67px] font-semibold font-nunito leading-tight" style={{fontFamily:'Montserrat'}}>
        Education Policy
      </h1>
      
      <motion.svg
        width="100%" 
        className="h-[40px] xs:h-[50px] sm:h-[60px] block -mt-1 xs:-mt-2 md:-ml-10 max-w-[600px]" 
        viewBox="0 0 600 60"  
        strokeLinecap="round"
      >
        <motion.path
          d="M50,40 Q300,-10 550,40" 
          stroke="#FA7C07"
          className="stroke-[8px] xs:stroke-[10px]"
          fill="transparent"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 1 }}
          transition={{ duration: 1.5, ease: "easeInOut" }}
          whileHover={{ 
            d: "M50,40 Q300,15 550,40",  
            transition: { duration: 0.8 } 
          }}
        />
      </motion.svg>
      
      <h2 className="text-[18px] xs:text-[22px] sm:text-[26px] md:text-[30px] lg:text-[34px] xl:text-[38px] font-semibold pl-1 text-[#3479FF] font-montserrat leading-tight" style={{
        textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",fontFamily:'Montserrat'
      }}>
        A New Era in Learning
      </h2>
    </div>
  </div>

  <div className="w-full md:w-[85%] lg:w-[80%] font-light text-center mt-3 xs:mt-4 sm:mt-5 md:mt-6 lg:mt-8 text-xs xs:text-md tracking-wide xs:text-lg sm:text-base md:text-lg font-roboto px-3 xs:px-4 line-clamp-4 md:line-clamp-none" style={{fontFamily:'Poppins'}}>
  The National Education Policy (NEP) 2020 is a groundbreaking reform designed to reshape education in India. Centered on holistic learning, skill development, and digital transformation, NEP 2020 prepares students for the future by emphasizing hands-on learning, vocational training, and multidisciplinary approaches.
</div>
</div>

      <div className='w-full h-auto'>
        <img src={nepPattern} alt="NEP Pattern" className="w-full h-auto" />
      </div>

      <div className='w-full h-auto py-3 flex flex-col justify-center items-center px-4'>
        <motion.div 
          whileHover={{scale:1.1, transition: { type: "spring", stiffness: 400, damping: 10 }}}  
          className='flex flex-row text-2xl sm:text-3xl md:text-4xl lg:text-5xl gap-3 font-bold'
          style={{
            fontFamily: "Montserrat",
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)"
          }}
        >
          <div className='text-black' style={{fontFamily:'Montserrat'}}>Why</div> 
          <div className='text-[#3572FF]' style={{fontFamily:'Montserrat'}}>NEP 2020 ?</div>
        </motion.div>

        <div className='w-full h-auto flex flex-col sm:flex-row justify-center sm:justify-between pt-7 xs:mt-8 sm:mt-[3%] xs:gap-12 px-0 sm:px-20 gap-6 sm:gap-4'>
     
          <div className="relative w-full sm:w-[280px] md:w-[330px] h-[120px] sm:h-[150px] flex flex-col items-center justify-start">
            <div className="bg-[#FF006E] w-full h-full rounded-2xl flex items-center xs:text-md justify-center text-white text-center px-4 text-sm sm:text-md font-medium
                          shadow-[inset_0_0_25px_rgba(0,0,0,0.4),0_10px_25px_rgba(0,0,0,0.4)] 
                          hover:shadow-[inset_0_0_30px_rgba(0,0,0,0.5),0_15px_30px_rgba(0,0,0,0.5)] 
                          transition-all duration-300 transform hover:-translate-y-1" 
                          style={{fontFamily:'Poppins'}}>
              Shifts from rote learning to skill-based education
            </div>
            <div className="absolute -top-6 w-[50px] h-[50px] sm:w-[60px] sm:h-[60px] bg-[#FF006E] rounded-full ring-4 ring-white flex items-center justify-center
                          shadow-lg hover:scale-110 transition-transform duration-300">
              <img src={nepwhy} alt="icon" className="w-[25px] h-[25px] sm:w-[30px] sm:h-[30px]" />
            </div>
          </div>

         
          <div className="relative w-full sm:w-[280px] md:w-[330px] h-[120px] sm:h-[150px] flex flex-col items-center justify-start">
            <div className="bg-[#704FE6] w-full h-full rounded-2xl flex items-center justify-center xs:text-md text-white text-center px-4 text-sm sm:text-md font-medium
                          shadow-[inset_0_0_25px_rgba(0,0,0,0.4),0_10px_25px_rgba(0,0,0,0.4)] 
                          hover:shadow-[inset_0_0_30px_rgba(0,0,0,0.5),0_15px_30px_rgba(0,0,0,0.5)] 
                          transition-all duration-300 transform hover:-translate-y-1" 
                          style={{fontFamily:'Poppins'}}>
              Focuses on 21st century skills: Critical thinking, creativity, problem-solving
            </div>
            <div className="absolute -top-6 w-[50px] h-[50px] sm:w-[60px] sm:h-[60px] bg-[#704FE6] rounded-full ring-4 ring-white flex items-center justify-center
                          shadow-lg hover:scale-110 transition-transform duration-300">
              <img src={nepwh2} alt="icon" className="w-[25px] h-[25px] sm:w-[30px] sm:h-[30px]" />
            </div>
          </div>

         
          <div className="relative w-full sm:w-[280px] md:w-[330px] h-[120px] sm:h-[150px] flex flex-col items-center justify-start">
            <div className="bg-[#FF854B] w-full h-full rounded-2xl flex items-center justify-center xs:text-md text-white text-center px-4 text-sm sm:text-md font-medium
                          shadow-[inset_0_0_25px_rgba(0,0,0,0.4),0_10px_25px_rgba(0,0,0,0.4)] 
                          hover:shadow-[inset_0_0_30px_rgba(0,0,0,0.5),0_15px_30px_rgba(0,0,0,0.5)] 
                          transition-all duration-300 transform hover:-translate-y-1" 
                          style={{fontFamily:'Poppins'}}>
              Blends academics with vocational and technological advancements
            </div>
            <div className="absolute -top-6 w-[50px] h-[50px] sm:w-[60px] sm:h-[60px] bg-[#FF854B] rounded-full ring-4 ring-white flex items-center justify-center
                          shadow-lg hover:scale-110 transition-transform duration-300">
              <img src={nepwhy} alt="icon" className="w-[25px] h-[25px] sm:w-[30px] sm:h-[30px]" />
            </div>
          </div>
        </div>
      </div>

      <div className="relative w-full h-auto overflow-hidden ">

      <style jsx global>{`
  @keyframes itemRise {
    0% { transform: translateY(0); }
    100% { transform: translateY(-5px); box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1); }
  }
  @keyframes borderGlow {
    0%, 100% { box-shadow: 0 0 5px rgba(53, 114, 255, 0.5); }
    50% { box-shadow: 0 0 15px rgba(53, 114, 255, 0.8); }
  }
  @keyframes iconPulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.2); }
  }
  @keyframes float {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-20px); }
  }
  .floating-dot {
    position: absolute;
    border-radius: 50%;
    animation: float ease-in-out infinite;
  }
  .dots-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    overflow: hidden;
  }
`}</style>

<div className="relative w-full h-auto overflow-hidden mt-5">

  <div className="absolute z-0 w-full h-full">
    <div className="relative h-full">
      <img
        src={leftellip}
        alt="half ellipse"
        className="h-[200px] sm:h-[250px] md:h-[320px] object-contain"
      />
      <img
        src={star}
        alt="star"
        className="absolute top-[20%] sm:top-[25%] left-[6%] h-[30px] w-[30px] sm:h-[40px] sm:w-[40px] md:h-[50px] md:w-[50px]"
      />
      
      <div className="dots-container">
        {[5, 15, 25, 35, 45, 55, 65, 75, 85, 95, 10, 20, 30, 40, 50, 60, 70, 80, 90].map((top, i) => (
          <div 
            key={i}
            className="floating-dot"
            style={{
              top: `${top}%`,
              left: `${Math.random() * 100}%`,
              width: `${6 + (i % 5)}px`,
              height: `${6 + (i % 5)}px`,
              backgroundColor: ['#3572FF', '#06AED4', '#EC7D4E', '#9F7AEA', '#7F56D9', '#F59E0B'][i % 6],
              animationDelay: `${i * 0.2}s`,
              animationDuration: `${4 + (i % 6)}s`,
              opacity: 0.7
            }}
          />
        ))}
      </div>
    </div>
  </div>

  <div className="relative z-10 w-full h-full flex-col flex justify-center px-4 sm:px-6">
    <motion.div 
      whileHover={{scale:1.1, transition: { type: "spring", stiffness: 400, damping: 10 }}} 
      className="w-full flex justify-center mt-8 sm:mt-[5%] font-bold text-3xl sm:text-4xl md:text-5xl text-[#3572FF]"
      style={{
        fontFamily: "Montserrat",
        textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)"
      }}
    >
      Key Highlights
    </motion.div>

    <div className="w-full h-auto flex flex-col lg:flex-row lg:justify-between gap-8 mt-6 sm:mt-10">
    <div className="w-full lg:w-[60%] flex flex-col items-center gap-4 pt-4 lg:pt-10 px-4 sm:px-0">

  <div className="w-full flex justify-center">
    <div>
      <div className="relative w-full max-w-xl gap-5 items-center px-4 sm:px-6 py-3 sm:py-4 flex flex-row rounded-xl bg-white border border-gray-200 hover:animate-[itemRise_0.3s_ease-out_forwards] cursor-pointer group transition-all duration-200">
        <div className="absolute inset-0 rounded-xl border-2 border-transparent group-hover:border-[#3572FF] group-hover:animate-[borderGlow_1.5s_ease-in-out_infinite]" />
        <div className="p-2 transition-colors">
          <img src={vector} className="w-3 h-3 group-hover:animate-[iconPulse_1s_ease-in-out_infinite]" />
        </div>
        <div className="font-bold text-base sm:text-lg text-gray-800 group-hover:text-[#3572FF] transition-colors" style={{ fontFamily: "Montserrat" }}>
          Language & Cultural Fusion
        </div>
        <div className="absolute right-3 sm:right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          
        </div>
      </div>
    </div>
  </div>

  <div className="w-full flex justify-center">
    <div>
      <div className="relative w-full max-w-xl gap-5 items-center px-4 sm:px-6 py-3 sm:py-4 flex flex-row rounded-xl bg-white border border-gray-200 hover:animate-[itemRise_0.3s_ease-out_forwards] cursor-pointer group transition-all duration-200">
        <div className="absolute inset-0 rounded-xl border-2 border-transparent group-hover:border-[#3572FF] group-hover:animate-[borderGlow_1.5s_ease-in-out_infinite]" />
        <div className="p-2 transition-colors">
          <img src={vector} className="w-3 h-3 group-hover:animate-[iconPulse_1s_ease-in-out_infinite]" />
        </div>
        <div className="font-bold text-base sm:text-lg text-gray-800 group-hover:text-[#3572FF] transition-colors" style={{ fontFamily: "Montserrat" }}>
          New School Structure (5+3+3+4)
        </div>
        <div className="absolute right-3 sm:right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        </div>
      </div>
    </div>
  </div>

  <div className="w-full flex justify-center">
    <div>
      <div className="relative w-full max-w-xl gap-5 items-center px-4 sm:px-6 py-3 sm:py-4 flex flex-row rounded-xl bg-white border border-gray-200 hover:animate-[itemRise_0.3s_ease-out_forwards] cursor-pointer group transition-all duration-200">
        <div className="absolute inset-0 rounded-xl border-2 border-transparent group-hover:border-[#3572FF] group-hover:animate-[borderGlow_1.5s_ease-in-out_infinite]" />
        <div className="p-2 transition-colors">
          <img src={vector} className="w-3 h-3 group-hover:animate-[iconPulse_1s_ease-in-out_infinite]" />
        </div>
        <div className="font-bold text-base sm:text-lg text-gray-800 group-hover:text-[#3572FF] transition-colors" style={{ fontFamily: "Montserrat" }}>
          Skill-Based & Experiential Learning
        </div>
        <div className="absolute right-3 sm:right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
         
        </div>
      </div>
    </div>
  </div>

  <div className="w-full flex justify-center">
    <div>
      <div className="relative w-full max-w-xl gap-5 items-center px-4 sm:px-6 py-3 sm:py-4 flex flex-row rounded-xl bg-white border border-gray-200 hover:animate-[itemRise_0.3s_ease-out_forwards] cursor-pointer group transition-all duration-200">
        <div className="absolute inset-0 rounded-xl border-2 border-transparent group-hover:border-[#3572FF] group-hover:animate-[borderGlow_1.5s_ease-in-out_infinite]" />
        <div className="p-2 transition-colors">
          <img src={vector} className="w-3 h-3 group-hover:animate-[iconPulse_1s_ease-in-out_infinite]" />
        </div>
        <div className="font-bold text-base sm:text-lg text-gray-800 group-hover:text-[#3572FF] transition-colors" style={{ fontFamily: "Montserrat" }}>
          Technology Integration & Digital Learning
        </div>
        <div className="absolute right-3 sm:right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          
        </div>
      </div>
    </div>
  </div>

  
  <div className="w-full flex justify-center">
    <div>
      <div className="relative w-full max-w-xl gap-5 items-center px-4 sm:px-6 py-3 sm:py-4 flex flex-row rounded-xl bg-white border border-gray-200 hover:animate-[itemRise_0.3s_ease-out_forwards] cursor-pointer group transition-all duration-200">
        <div className="absolute inset-0 rounded-xl border-2 border-transparent group-hover:border-[#3572FF] group-hover:animate-[borderGlow_1.5s_ease-in-out_infinite]" />
        <div className="p-2 transition-colors">
          <img src={vector} className="w-3 h-3 group-hover:animate-[iconPulse_1s_ease-in-out_infinite]" />
        </div>
        <div className="font-bold text-base sm:text-lg text-gray-800 group-hover:text-[#3572FF] transition-colors" style={{ fontFamily: "Montserrat" }}>
          Flexible & Multidisciplinary Higher Education
        </div>
        <div className="absolute right-3 sm:right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
         
        </div>
      </div>
    </div>
  </div>
</div>


      <div className="w-full lg:w-[40%] h-auto flex justify-center lg:justify-end">
        <img src={nepboy} alt="nepboy" className="w-full max-w-[400px] lg:max-w-none h-auto lg:h-[400px] xl:h-[520px] object-contain" />
      </div>
    </div>
  </div>
</div>

      </div>
<div className="relative w-full h-auto overflow-hidden mt-6 sm:mt-8 md:mt-10 lg:mt-12 xl:mt-8">
  <style>
    {`
      .floating-dot {
        position: absolute;
        border-radius: 50%;
        animation-name: float;
        animation-timing-function: ease-in-out;
        animation-iteration-count: infinite;
      }

      @keyframes float {
        0% {
          transform: translateY(0px);
          opacity: 1;
        }
        50% {
          transform: translateY(-20px);
          opacity: 0.7;
        }
        100% {
          transform: translateY(0px);
          opacity: 1;
        }
      }
    `}
  </style>

  <div className="absolute z-0 w-full h-full">
    <div className="relative h-full">
      <img
        src={rightelli}
        alt="half ellipse"
        className="h-[200px] xs:h-[250px] sm:h-[350px] md:h-[450px] lg:h-[500px] xl:h-[550px] ml-auto object-contain"
      />
      <img
        src={rightstart}
        alt="star"
        className="absolute top-[20%] xs:top-[25%] sm:top-[30%] md:top-[35%] lg:top-[38%] right-[6%] h-[30px] w-[20px] xs:h-[35px] xs:w-[25px] sm:h-[45px] sm:w-[30px] md:h-[55px] md:w-[40px] lg:h-[65px] lg:w-[45px] xl:h-[70px] xl:w-[50px]"
      />
    </div>
  </div>

  <div className="absolute inset-0 z-0">
    {[...Array(15)].map((_, i) => {
      const colors = ['#FF6B6B', '#6BCB77', '#4D96FF', '#FFD93D', '#A66DD4', '#00C2CB'];
      const color = colors[i % colors.length];
      return (
        <div
          key={i}
          className="floating-dot"
          style={{
            top: `${Math.random() * 90}%`,
            left: `${Math.random() * 90}%`,
            backgroundColor: color,
            boxShadow: `0 0 10px ${color}`,
            animationDelay: `${i * 0.3}s`,
            animationDuration: `${5 + (i % 4)}s`,
            width: `${6 + (i % 4)}px`,
            height: `${6 + (i % 4)}px`,
          }}
        />
      );
    })}
  </div>

  <div className="relative z-10 w-full h-full items-center flex-col flex px-4 xs:px-5 sm:px-6 md:px-8 lg:px-10 xl:px-12">
    <div className="w-full flex justify-center flex-col items-center">
      <motion.div 
        whileHover={{scale:1.1, transition: { type: "spring", stiffness: 400, damping: 10 }}} 
        className="mt-6 xs:mt-7 sm:mt-8 md:mt-10 lg:mt-12 text-center font-bold text-xl xs:text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-5xl text-[#0A9CF1]"
        style={{
          fontFamily: "Montserrat",
          textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)"
        }}
      >
        How Simplifying Skills Aligns
      </motion.div>
      <div
        className="w-full flex justify-center mt-1 xs:mt-2 sm:mt-3 font-normal text-lg xs:text-xl sm:text-2xl md:text-3xl text-black"
        style={{
          fontFamily: "Montserrat",
          textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)"
        }}
      >
        with NEP 2020
      </div>
    </div>
     
    <div className="w-full  h-auto pt-4 pb-6 xs:pt-5 xs:pb-7 sm:pt-6 sm:pb-8 md:pt-7 md:pb-9 lg:pt-8 lg:pb-10 flex flex-col sm:flex-row justify-center items-center gap-3 xs:gap-4 sm:gap-5 md:gap-6 lg:gap-7 xl:gap-8 flex-wrap">
  <motion.div
    className="w-[90%] xs:w-[85%] sm:w-[45%] md:w-[48%] lg:w-[45%] xl:w-[28%] h-[150px] xs:h-[170px] sm:h-[180px] md:h-[200px] lg:h-[220px] xl:h-[240px] bg-[#d9f5fb] items-center rounded-xl sm:rounded-2xl flex flex-col shadow-lg sm:shadow-xl p-3 xs:p-4"
    whileHover={{
      boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
      scale: 1.02
    }}
    transition={{ type: "spring", stiffness: 400, damping: 10 }}
  >
    <img src={brain} alt="brain" className="w-[40px] h-[50px] xs:w-[45px] xs:h-[55px] sm:w-[50px] sm:h-[60px] md:w-[60px] md:h-[70px] lg:w-[65px] lg:h-[75px] m-1 xs:m-1" />
    <div className="flex flex-col gap-1 xs:gap-2 mt-1 xs:mt-2 items-center" style={{ fontFamily: "Montserrat" }}>
      <div className="text-[#FF9E5A] font-bold text-base xs:text-lg sm:text-xl md:text-2xl" style={{ fontFamily: "Montserrat" }}>
        Immersive Learning
      </div>
      <div className="text-center  xs:text-md sm:text-base md:text-xl lg:text-lg xl:text-xl "style={{fontFamily:'Poppins'}}>
        Engaging, hands-on education for deeper understanding. 
      </div>
    </div>
  </motion.div>
  
  <motion.div
    className="w-[90%] xs:w-[85%] sm:w-[45%] md:w-[48%] lg:w-[45%] xl:w-[28%] h-[150px] xs:h-[170px] sm:h-[180px] md:h-[200px] lg:h-[220px] xl:h-[240px] bg-[#d9f5fb] items-center rounded-xl sm:rounded-2xl flex flex-col shadow-lg sm:shadow-xl p-3 xs:p-4"
    whileHover={{
      boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
      scale: 1.02
    }}
    transition={{ type: "spring", stiffness: 400, damping: 10 }}
  >
    <img src={digital} alt="digital" className="w-[40px] h-[50px] xs:w-[45px] xs:h-[55px] sm:w-[50px] sm:h-[60px] md:w-[60px] md:h-[70px] lg:w-[65px] lg:h-[75px] m-1 xs:m-2" />
    <div className="flex flex-col gap-1 xs:gap-2 mt-1 xs:mt-2 items-center" style={{ fontFamily: "Montserrat" }}>
      <div className="text-[#FF9E5A] font-bold text-base xs:text-lg sm:text-xl md:text-2xl"style={{ fontFamily: "Montserrat" }}>
        Digital Upskilling
      </div>
      <div className="text-center  xs:text-md sm:text-base md:text-xl lg:text-lg xl:text-xl" style={{fontFamily:'Poppins'}}>
        Tech-driven learning for 21st-century careers. 
      </div>
    </div>
  </motion.div>

  <motion.div
    className="w-[90%] xs:w-[85%] sm:w-[45%] md:w-[48%] lg:w-[45%] xl:w-[28%] h-[150px] xs:h-[170px] sm:h-[180px] md:h-[200px] lg:h-[220px] xl:h-[240px] bg-[#d9f5fb] items-center rounded-xl sm:rounded-2xl flex flex-col shadow-lg sm:shadow-xl p-3 xs:p-4"
    whileHover={{
      boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
      scale: 1.02
    }}
    transition={{ type: "spring", stiffness: 400, damping: 10 }}
  >
    <img src={creativity} alt="creativity" className="w-[40px] h-[50px] xs:w-[45px] xs:h-[55px] sm:w-[50px] sm:h-[60px] md:w-[60px] md:h-[70px] lg:w-[65px] lg:h-[75px] m-1 xs:m-2" />
    <div className="flex flex-col gap-1 xs:gap-2 mt-1 xs:mt-2 items-center" style={{ fontFamily: "Montserrat" }}>
      <div className="text-[#FF9E5A] font-bold text-base xs:text-lg sm:text-xl md:text-2xl"style={{ fontFamily: "Montserrat" }}>
        Holistic Development
      </div>
      <div className="text-center  xs:text-md sm:text-base md:text-xl lg:text-lg xl:text-xl " style={{fontFamily:'Poppins'}}>
        A balanced approach to mind, body, and creativity.
      </div>
    </div>
  </motion.div>
  
  <motion.div
    className="w-[90%] xs:w-[85%] sm:w-[45%] md:w-[48%] lg:w-[45%] xl:w-[28%] h-[150px] xs:h-[170px] sm:h-[180px] md:h-[200px] lg:h-[220px] xl:h-[240px] bg-[#d9f5fb] items-center rounded-xl sm:rounded-2xl flex flex-col shadow-lg sm:shadow-xl p-3 xs:p-4"
    whileHover={{
      boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
      scale: 1.02
    }}
    transition={{ type: "spring", stiffness: 400, damping: 10 }}
  >
    <img src={cross} alt="cross" className="w-[40px] h-[50px] xs:w-[45px] xs:h-[55px] sm:w-[50px] sm:h-[60px] md:w-[60px] md:h-[70px] lg:w-[65px] lg:h-[75px] m-1 xs:m-2" />
    <div className="flex flex-col gap-1 xs:gap-2 mt-1 xs:mt-2 items-center" style={{ fontFamily: "Montserrat" }}>
      <div className="text-[#FF9E5A] font-bold text-base xs:text-lg sm:text-xl md:text-2xl" style={{ fontFamily: "Montserrat" }}>
        Cultural Fusion
      </div>
      <div className="text-center  xs:text-md sm:text-base md:text-xl lg:text-lg xl:text-xl " style={{fontFamily:'Poppins'}}>
        Blending tradition with innovation in education.
      </div>
    </div>
  </motion.div>
</div>
  </div>
</div>

<div className="w-full h-auto py-3 xs:py-4 sm:py-5 md:py-6 lg:py-7 flex justify-center flex-col gap-y-3 xs:gap-y-4 sm:gap-y-5 items-center relative overflow-hidden px-3 xs:px-4 sm:px-5 md:px-6 lg:px-8">

  <style jsx>{`
    .floating-dot {
      position: absolute;
      border-radius: 50%;
      animation: float ease-in-out infinite;
      opacity: 0.8;
      box-shadow: 0 0 8px currentColor;
    }
    
    @keyframes float {
      0%, 100% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(-15px);
      }
    }

    /* Reduce animation intensity on mobile */
    @media (max-width: 640px) {
      .floating-dot {
        box-shadow: 0 0 5px currentColor;
      }
      @keyframes float {
        50% {
          transform: translateY(-10px);
        }
      }
    }
  `}</style>

  {/* Floating dots - reduced number on mobile */}
  <div className="absolute inset-0 z-0">
    {[...Array(15)].map((_, i) => {
      const colors = ['#FF6B6B', '#FFD93D', '#6BCB77', '#4D96FF', '#A66DD4'];
      const randomColor = colors[i % colors.length];
      const isMobile = typeof window !== 'undefined' && window.innerWidth < 640;
      const dotCount = isMobile ? 10 : 15;
      
      if (isMobile && i >= dotCount) return null;
      
      return (
        <div
          key={i}
          className="floating-dot"
          style={{
            top: `${Math.random() * 90}%`,
            left: `${Math.random() * 90}%`,
            backgroundColor: randomColor,
            animationDelay: `${i * 0.3}s`,
            animationDuration: `${4 + (i % 3)}s`,
            width: `${isMobile ? 4 + (i % 3) : 6 + (i % 4)}px`,
            height: `${isMobile ? 4 + (i % 3) : 6 + (i % 4)}px`,
          }}
        />
      );
    })}
  </div>

  {/* Title with responsive font sizes */}
  <motion.div
    whileHover={{
      scale: 1.05,
      transition: { type: "spring", stiffness: 400, damping: 10 }
    }}
    className="text-2xl xs:text-3xl sm:text-4xl md:text-[2.75rem] lg:text-5xl xl:text-[3.5rem] font-bold text-[#8155D6] z-10 inline-block px-2 text-center"
    style={{
      fontFamily: "Montserrat",
      textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
      lineHeight: 1.2
    }}
  >
    A New Era in Learning
  </motion.div>

  {/* Description with responsive sizing */}
  <motion.div
    variants={{
      hidden: { opacity: 0, y: 15 },
      visible: { 
        opacity: 1, 
        y: 0, 
        transition: { 
          duration: 0.6,
          ease: "easeOut"
        } 
      }
    }}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.3 }}
    className="w-full px-2 xs:px-3 sm:px-0 md:w-[85%] lg:w-[70%] xl:w-[60%] text-xs xs:text-sm  md:text-lg lg:text-lg  leading-relaxed sm:leading-relaxed md:leading-relaxed text-center z-10"
    style={{
      fontFamily:'Poppins',
      maxWidth: '1200px'
    }}
  >
    NEP 2020 is revolutionizing education by making learning skill-driven, flexible, and globally competitive. As an EdTech leader, Simplifying Skills is committed to empowering students with real-world knowledge, practical expertise, and innovative thinking.
  </motion.div>
</div>
    </div>
  )
}



